import { render, staticRenderFns } from "./PromotionRankingBanner.vue?vue&type=template&id=7a392af0&scoped=true"
import script from "./PromotionRankingBanner.vue?vue&type=script&lang=js"
export * from "./PromotionRankingBanner.vue?vue&type=script&lang=js"
import style0 from "./PromotionRankingBanner.vue?vue&type=style&index=0&id=7a392af0&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a392af0",
  null
  
)

export default component.exports